export const environment = {
  production: false,
  environment: 'dev',
  apiUrl: 'https://app-sititramites.sitiapp.com',
  recaptchaV2SiteKey: '6LfKuLkqAAAAAMUMHvvekHvPI3iKcBUdrWH9F-mm',
  recaptchaV3SiteKey: '6Lf0_LkqAAAAAE1U32eLQ6QevROo5FUid_oUTkIX'
};
